export default {
  Integrations: 'Integrations',
  Store: 'Store',
  MyApps: 'MyApps',
  IntegrationsManagement: 'IntegrationsManagement',
  IntegrationListings: 'IntegrationListings',
  IntegrationManagement: 'IntegrationManagement',
  TokenManagement: 'TokenManagementUi'
}
